import { c as _c } from "react/compiler-runtime";
import { CodeBlock } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import LogField from '../log-field';
type LogContentFieldProps = {
  base64Value: string | undefined;
};
const LogContentField = t0 => {
  const $ = _c(29);
  const {
    base64Value
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "details.logs.detailsDialog"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("vault-proxy", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const label = t2;
  const getDecoded = _temp2;
  const getParsed = _temp3;
  let T0;
  let t10;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== base64Value || $[4] !== label) {
    t10 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const decoded_0 = getDecoded(base64Value);
      if (!decoded_0) {
        let t11;
        if ($[14] !== label) {
          t11 = <LogField label={label} value={undefined} />;
          $[14] = label;
          $[15] = t11;
        } else {
          t11 = $[15];
        }
        t10 = t11;
        break bb0;
      }
      const parsed = getParsed(decoded_0);
      t8 = "flex flex-col gap-2 [>*:bg-secondary]";
      if ($[16] !== label) {
        t9 = <span className="text-body-2 text-primary">{label}</span>;
        $[16] = label;
        $[17] = t9;
      } else {
        t9 = $[17];
      }
      T0 = CodeBlock;
      t3 = "json";
      t4 = true;
      t5 = "secondary";
      t6 = true;
      t7 = typeof parsed === "string" ? parsed : JSON.stringify(parsed, null, 2);
    }
    $[3] = base64Value;
    $[4] = label;
    $[5] = T0;
    $[6] = t10;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    T0 = $[5];
    t10 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  if (t10 !== Symbol.for("react.early_return_sentinel")) {
    return t10;
  }
  let t11;
  if ($[18] !== T0 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t11 = <T0 language={t3} showLineNumbers={t4} backgroundColor={t5} hideHeader={t6}>{t7}</T0>;
    $[18] = T0;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t8 || $[27] !== t9) {
    t12 = <div className={t8}>{t9}{t11}</div>;
    $[25] = t11;
    $[26] = t8;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
export default LogContentField;
function _temp($) {
  return $.content;
}
function _temp2(base64Value_0) {
  if (!base64Value_0) {
    return;
  }
  try {
    return atob(base64Value_0);
  } catch {
    return;
  }
}
function _temp3(decoded) {
  try {
    return JSON.parse(decoded);
  } catch {
    return decoded;
  }
}